export default __webpack_public_path__ + "static/small-image-norsk-3-5ea6240461aa1ef8896594299c70bf53.png";